import React from 'react';
import { motion } from 'framer-motion';
import { Clock, MessageCircle, Zap } from 'lucide-react';
export function ProblemReframe() {
  return <section className="py-20 bg-gray-900 text-white px-4 relative overflow-hidden" data-id="element-192">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-pink-600 rounded-full mix-blend-screen filter blur-[100px] opacity-20" data-id="element-193"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-194">
        <div className="text-center mb-16" data-id="element-195">
          <h2 className="text-3xl md:text-5xl font-black mb-6" data-id="element-196">
            El problema no es el vocabulario. <br data-id="element-197" />
            <span className="text-yellow-400" data-id="element-198">Es el momento.</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-199">
            La mayoría de soluciones te preparan para “saber”. Pero tu vida te
            exige “responder” en 2 segundos.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-200">
          <div className="bg-gray-800 p-8 rounded-2xl border border-gray-700" data-id="element-201">
            <div className="w-12 h-12 bg-pink-500/20 rounded-full flex items-center justify-center mb-6" data-id="element-202">
              <Clock className="w-6 h-6 text-pink-400" data-id="element-203" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-204">Presión Social</h3>
            <p className="text-gray-400" data-id="element-205">
              Cuando llega la presión social, la gramática no te salva.
              Necesitas velocidad.
            </p>
          </div>

          <div className="bg-gray-800 p-8 rounded-2xl border border-gray-700" data-id="element-206">
            <div className="w-12 h-12 bg-yellow-500/20 rounded-full flex items-center justify-center mb-6" data-id="element-207">
              <MessageCircle className="w-6 h-6 text-yellow-400" data-id="element-208" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-209">Frases Listas</h3>
            <p className="text-gray-400" data-id="element-210">
              Lo que te salva es tener una frase lista, no conjugar verbos en tu
              mente.
            </p>
          </div>

          <div className="bg-gray-800 p-8 rounded-2xl border border-gray-700" data-id="element-211">
            <div className="w-12 h-12 bg-orange-500/20 rounded-full flex items-center justify-center mb-6" data-id="element-212">
              <Zap className="w-6 h-6 text-orange-400" data-id="element-213" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-214">Ganar Tiempo</h3>
            <p className="text-gray-400" data-id="element-215">
              Saber cómo ganar tiempo mientras tu cerebro procesa la respuesta.
            </p>
          </div>
        </div>
      </div>
    </section>;
}